import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 119 31.5",
    }}
    viewBox="0 0 119 31.5"
    {...props}
  >
    <style>{`.st0{fill:none;stroke:${strokeColor};stroke-miterlimit:10}`}</style>
    <g id="Layer_2_00000078034766437017628660000014651781136001089711_">
      <path
        id="Layer_4_00000012445408901645575590000007929448687252741774_"
        d="M28.7 20c1.1.4 1.5 1.5 1.5 1.7v1.4c0 .1.1.1.1.1l.1.2.1.6h57.1v-.6l.1.1"
        className="st0"
      />
      <path d="M29 20.5C29 7.7 7.1 5.2 7.6 22" className="st0" />
      <g id="Layer_2_00000155121443628905800900000004859472908403130512_">
        <ellipse cx={18.2} cy={21.1} className="st0" rx={9.5} ry={9.8} />
        <path
          d="M10.9 21.1c0 4.1 3.3 7.1 7.1 7.1s7.1-3.3 7.1-7.1S21.8 14 18 14c-3.8-.2-7.1 3.3-7.1 7.1z"
          className="st0"
        />
        <path
          d="M11.1 21.4c1-.1 2-.2 3-.2.9-.1 1-1.4.2-2-.7-.6-1.4-1-2.1-1.5l-.1-.2c.1-.2.7-1.3 1.3-1.4h.2l1.9 1.9c.7.7 1.9.1 1.9-.7-.1-1-.1-2.1-.2-3.1.2-.2 2-.2 2.1 0-.1 1-.1 2.1-.2 3.1s1.2 1.4 1.9.7l1.9-1.9 1.2 1.5v.2c-.6.5-1 .9-1.7 1.3-.7.6-.6 1.9.2 2 1 .1 1.3.1 2.4.2l-.3 2.1c.1.1-1.2 0-2.2-.4-.7-.2-1.5.7-1.3 1.4.5.9.6 1.3 1.2 2.1 0 0-1.2 1-1.4 1-.1 0-.2 0-.2-.1-.2-.9-.6-1.5-.9-2.7-.2-.9-1.6-.9-2.1 0-.3.9-.6 1.5-.9 2.6 0 0-.1.5-.2.5-.2 0-1.7-.4-1.9-.7-.1-.1.3-.7.3-.7.5-.9.7-1.4 1.3-2.2.2-.7-.2-1.5-1.3-1.4-.9.2-2.7.5-3.7.7-.1-.2-.5-1.6-.3-2.1z"
          className="st0"
        />
        <path
          d="M17 21c0 .6.5 1 1 1s1-.5 1-1-.5-1-1-1c-.6-.1-1 .4-1 1z"
          className="st0"
        />
        <circle cx={15.8} cy={21.2} r={0.5} className="st0" />
        <circle cx={19.8} cy={19.8} r={0.5} className="st0" />
        <circle cx={17.6} cy={23.1} r={0.5} className="st0" />
        <circle cx={17.5} cy={18.9} r={0.5} className="st0" />
        <circle cx={20} cy={22} r={0.5} className="st0" />
      </g>
      <g id="Layer_2_00000016073657216702278980000013240535702283208866_">
        <ellipse cx={98.7} cy={21} className="st0" rx={9.5} ry={9.8} />
        <path
          d="M91.4 21c0 4.1 3.3 7.1 7.1 7.1s7.1-3.3 7.1-7.1-3.3-7.1-7.1-7.1c-3.8-.2-7.1 3.3-7.1 7.1z"
          className="st0"
        />
        <path
          d="M91.6 21.3c1-.1 2-.2 3-.2.9-.1 1-1.4.2-2-.7-.6-1.4-1-2.1-1.5l-.1-.2c.1-.2.7-1.3 1.3-1.4h.2l1.9 1.9c.7.7 1.9.1 1.9-.7-.1-1-.1-2.1-.2-3.1.2-.2 2-.2 2.1 0-.1 1-.1 2.1-.2 3.1s1.2 1.4 1.9.7l1.9-1.9 1.2 1.5v.2c-.6.5-1 .9-1.7 1.3-.7.6-.6 1.9.2 2 1 .1 1.3.1 2.4.2l-.3 2.1c.1.1-1.2 0-2.2-.4-.7-.2-1.5.7-1.3 1.4.5.9.6 1.3 1.2 2.1 0 0-1.2 1-1.4 1-.1 0-.2 0-.2-.1-.2-.9-.6-1.5-.9-2.7-.2-.9-1.6-.9-2.1 0-.3.9-.6 1.5-.9 2.6 0 0-.1.5-.2.5-.2 0-1.7-.4-1.9-.7-.1-.1.3-.7.3-.7.5-.9.7-1.4 1.3-2.2.2-.7-.2-1.5-1.3-1.4-.9.2-2.7.5-3.7.7-.1-.2-.5-1.6-.3-2.1z"
          className="st0"
        />
        <path
          d="M97.5 20.9c0 .6.5 1 1 1s1-.5 1-1-.5-1-1-1c-.6-.1-1 .4-1 1z"
          className="st0"
        />
        <circle cx={96.3} cy={21.1} r={0.5} className="st0" />
        <circle cx={100.3} cy={19.7} r={0.5} className="st0" />
        <circle cx={98.1} cy={23} r={0.5} className="st0" />
        <circle cx={98} cy={18.8} r={0.5} className="st0" />
        <circle cx={100.5} cy={21.9} r={0.5} className="st0" />
      </g>
    </g>
    <g id="Layer_3">
      <path
        d="M8.1 21.5H4.4l-.5-.1-2.6-.8c-.2-.1-.4-.3-.4-.7l-.1-.5v-.8l.2-1c.1-.3 0-.7-.1-1L.7 16l.2-4.6v-.9c0-.2 1-1 1.1-1.2l.6-1.6M109.4 22.8l4.6.1.8.2c.6 0 1.5-.3 1.3-.4l.6-.6 1.3-1.2c.5-.5.5-1.2.1-1.7l-1-1.4c-.2-.3-.3-.6-.2-1l.8-3.7c0-.2.1-.4.1-.6l-.2-6.1-.1-.7c0-.3-.1-.5-.3-.7M2.6 7.4H8c2 0 3.6-1.6 3.6-3.6l-.4-1.6-5 2c-.6.2-1.1.6-1.6 1l-2.1 2c0 .1 0 .2.1.2zM25.7 6.6h-3.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.1c.5 0 .9.4.9.9.1.5-.3.9-.9.9zM11.2 2.2 14.6.9M109.9 20.4c0-13.3-22.7-15.9-22.1 1.6M87.8 21.2l-.2 2.8M109.9 19.7v3.5"
        className="st0"
      />
    </g>
  </svg>
);
export default SvgComponent;
